export default "__VITE_ASSET__PzsNg$NS__"